module.exports = __webpack_public_path__ + "static/img/750x463_rx100m6_0606.96e1323.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homepage/kv/750x463_rx100m6_0606.jpg
// module id = rE1K
// module chunks = 1